export const getNewId = () => Math.ceil(Math.random() * 1000000000);
